import isBlank from '@im-frontend/utils/isBlank';

// Matches the range fmt.asDate enforces at format time (@im-frontend/utils/fmt).
// A parseable Date outside this range still round-trips as the literal string
// "Invalid Date" downstream, so the validator must reject it too.
const MIN_YEAR = 1900;
const MAX_YEAR = 2100;

export function isValidDate(date: unknown): date is Date {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return false;
  }
  const year = date.getFullYear();
  return year >= MIN_YEAR && year <= MAX_YEAR;
}

export function dateValidator(date?: Date | string) {
  if (isBlank(date) || isValidDate(date)) {
    return null;
  }
  return 'Please enter a valid date';
}

export function requiredDateValidator(date?: Date | string) {
  if (isValidDate(date)) {
    return null;
  }
  return 'Please enter a valid date';
}
